<template>
  <div class="images-download-card">
    <img
      @click="openDialog"
      width="100%"
      :src="img + '?resize=1&w=120'"
      :alt="title"
      class="d-block cursor-pointer"
    />
    <v-dialog max-width="800px" v-model="dialogDownload">
      <LoadingWidget v-if="loading" />
      <v-card v-if="!loading" class="dialog-card" flat>
        <v-btn
          class="dialog-close-btn white"
          @click="dialogDownload = false"
          icon
          color="white"
        >
          <v-icon color="primary">fas fa-times</v-icon>
        </v-btn>
        <img class="d-block" width="100%" :src="img" />
        <div
          @click="fileDownload(img, title)"
          class="download-btn d-flex justify-center align-center"
        >
          <v-icon color="white" size="80">fas fa-save</v-icon>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { fileDownload } from "../../utils/fileDownload";
import LoadingWidget from "../widgets/LoadingWidget.vue";

export default {
  components: { LoadingWidget },
  props: {
    title: {
      type: String,
    },
    img: {
      type: String,
      required: true,
    },
  },
  methods: {
    fileDownload,
    openDialog() {
      this.loading = true;
      this.dialogDownload = true;
      setTimeout(() => {
        this.loading = false;
      }, 600);
    },
  },
  data: () => ({
    dialogDownload: false,
    loading: false,
  }),
};
</script>
<style lang="scss">
.v-dialog {
  overflow: visible !important;
  box-shadow: none !important;
}
.dialog-card {
  position: relative;

  .download-btn {
    &:hover {
      opacity: 1;
    }
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #00000088;
    opacity: 0;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    z-index: 2;
  }
  .dialog-close-btn {
    position: absolute;
    right: -15px;
    top: -15px;
    z-index: 3;
  }
}
</style>

<style scoped lang="scss">
.images-download-card {
  img {
    height: 68px;
    width: 68px;
    object-fit: cover;
  }
}
</style>
